export enum ApiService {
  LOGO = 'logo',
  PRINTEXAMPLE = 'print_example',
}

export enum UploadStatus {
  INITIAL = 'initial',
  PROVIDING = 'providing',
  UPLOADING = 'uploading',
  SUCCESS = 'success',
}

export enum UploadExtensionCheck {
  PDF = 'pdf',
}
